import { Item, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  ImagePropertiesParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';

export type S09NewsListingProps = RenderingProps<
  {
    NoResultsText?: RichTextField;
    ScopeSearchToSection?: Item[];
  },
  {
    NumberOfSearchResultsPerPage?: string;
    ShouldDisplaySearchBox?: string;
  } & TranslationOptionsParams &
    AnchorTargetParams &
    ImagePropertiesParams
>;
